/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool

import React, { useEffect, useMemo, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_products } from '../store/reducers/homeReducer';
import config from '../config';
import GetSellerConfig from '../components/GetSellerConfig';

const Header                        = lazy(() => import('../components/Header'));
const Banner                        = lazy(() => import('../components/Banner'));
const Categorys                     = lazy(() => import('../components/Categorys'));
const MainIngredients               = lazy(() => import('../components/MainIngredients'));
const FeatureProducts               = lazy(() => import('../components/products/FeatureProducts'));
const Products                      = lazy(() => import('../components/products/Products'));
const CustomerTestimonialsHomePage  = lazy(() => import('../components/CustomerTestimonialsHomePage'));
const Footer                        = lazy(() => import('../components/Footer'));
//const GetSellerConfig             = lazy(() => import('../components/GetSellerConfig'));

const isVisible = (val) => val === 'Show';

const Home = () => {
    const dispatch = useDispatch();
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { seller } = useSelector((state) => state.seller);
    const { latest_product, topRated_product, discount_product, featured_product } =
        useSelector((state) => state.home);
    const { sellerComponentBackgroundColor } = GetSellerConfig();

    const {
        _id: sellerId,
        frontEndPrimaryColor1: primaryColor,
        frontEndSecondaryColor1: secondaryColor,
        hexOpacityColorSuffixes,
        productPluralTerm,
        isVisibleHomePageBanner,
        isVisibleHomePageCategoriesTop,
        isVisibleHomePageCategoriesBottom,
        isVisibleHomePageMainIngredientsTop,
        isVisibleHomePageMainIngredientsBottom,
        isVisibleHomePageFavoriteProducts,
        isVisibleHomePageThreeProductColumns,
        isVisibleCustomerTestimonials,
    } = seller ?? {};

    const [suffixDark, suffixMedium, suffixLight] = useMemo(() => {
        const parts = hexOpacityColorSuffixes?.split(';') ?? [];
        return [parts[0] ?? 'FF', parts[1] ?? '80', parts[2] ?? '1A'];
    }, [hexOpacityColorSuffixes]);

    const show = {
        banner:              isVisible(isVisibleHomePageBanner),
        categoriesTop:       isVisible(isVisibleHomePageCategoriesTop),
        categoriesBottom:    isVisible(isVisibleHomePageCategoriesBottom),
        ingredientsTop:      isVisible(isVisibleHomePageMainIngredientsTop),
        ingredientsBottom:   isVisible(isVisibleHomePageMainIngredientsBottom),
        favoriteProducts:    isVisible(isVisibleHomePageFavoriteProducts),
        threeColumns:        isVisible(isVisibleHomePageThreeProductColumns),
        testimonials:        isVisible(isVisibleCustomerTestimonials),
    };

    useEffect(() => {
        dispatch(get_products(sellerFrontendURL));
    }, [dispatch, sellerFrontendURL]);

    return (
        <div className='w-full'>
            <Suspense fallback={null}>
                <Header />
                <div style={{ backgroundColor: sellerComponentBackgroundColor }}>
                    {show.banner && (
                        <div className='w-full md-lg:mt-6'>
                            <Banner />
                        </div>
                    )}

                    {show.categoriesTop    && <Categorys />}
                    {show.ingredientsTop   && <MainIngredients />}
                    {show.favoriteProducts && <FeatureProducts products={featured_product} />}
                    {show.categoriesBottom && <Categorys />}
                    {show.ingredientsBottom && <MainIngredients />}

                    {show.threeColumns && (
                        <div className='py-4'>
                            <div className='w-[85%] flex flex-wrap mx-auto'>
                                <div className='grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-3'>
                                    <div className='overflow-hidden justify-items-center'>
                                        <Products
                                            title={`Latest ${productPluralTerm}`}
                                            products={latest_product}
                                            parentPage='Home'
                                        />
                                    </div>
                                    <div className='overflow-hidden justify-items-center'>
                                        <Products
                                            title='Chefs Choice'
                                            products={topRated_product}
                                            parentPage='Home'
                                        />
                                    </div>
                                    <div className='overflow-hidden justify-items-center'>
                                        <Products
                                            title={`Select ${productPluralTerm}`}
                                            products={discount_product}
                                            parentPage='Home'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {show.testimonials && <CustomerTestimonialsHomePage />}
                </div>
                <Footer />
            </Suspense>
        </div>
    );
};

export default Home;



//my original code
// import React, { useEffect, useState, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { get_products } from '../store/reducers/homeReducer';

// import config from '../config';

// const Header  = lazy(()=> import('../components/Header')) 
// const Banner = lazy(()=> import('../components/Banner'))
// const Categorys = lazy(()=> import('../components/Categorys'))
// const MainIngredients = lazy(()=> import('../components/MainIngredients'))
// const FeatureProducts = lazy(()=> import('../components/products/FeatureProducts')) 
// const Products = lazy(()=> import('../components/products/Products'))
// const CustomerTestimonialsHomePage = lazy(()=> import('../components/CustomerTestimonialsHomePage'))
// //const CustomerTestimonialsHomePage2 = lazy(()=> import('../components/CustomerTestimonialsHomePage2'))

// const Footer = lazy(()=> import('../components/Footer'))

// const Home = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL 

//     const { seller } = useSelector(state => state.seller)
//     const {products, latest_product, topRated_product, discount_product, featured_product} = useSelector(state => state.home)
    
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;
    
//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
//     const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';

//     const sellerProductPluralTerm = seller?.productPluralTerm
    
//     const sellerBoolShowHomePageBanner = seller?.isVisibleHomePageBanner === 'Show' ? true : false
//     const sellerBoolShowHomePageCategoriesTop =  seller?.isVisibleHomePageCategoriesTop === 'Show' ? true : false
//     const sellerBoolShowHomePageCategoriesBottom = seller?.isVisibleHomePageCategoriesBottom === 'Show' ? true : false
//     const sellerBoolShowHomePageMainIngredientsTop = seller?.isVisibleHomePageMainIngredientsTop === 'Show' ? true : false
//     const sellerBoolShowHomePageMainIngredientsBottom = seller?.isVisibleHomePageMainIngredientsBottom === 'Show' ? true : false
//     const sellerBoolShowHomePageFavoriteProducts = seller?.isVisibleHomePageFavoriteProducts === 'Show' ? true : false
//     const sellerBoolShowHomePageThreeProductColumns = seller?.isVisibleHomePageThreeProductColumns === 'Show' ? true : false
//     const sellerBoolShowCustomerTestimonials = seller?.isVisibleCustomerTestimonials  === 'Show' ? true : false

//     const dispatch = useDispatch()
    
//     useEffect(() => {
//         dispatch(get_products(sellerFrontendURL))
//     },[])

//     //console.log('home page')
//     //console.log(categorys)
//     //console.log(mainIngredients)
//     //console.log('home featured_product ', featured_product)//works here
//     //console.log(products)//works here

//     return (
//         <div className='w-full'>
//             <Header />
//             <div className={` ${sellerBoolShowHomePageBanner ? 'w-full md-lg:mt-6' : 'hidden'} `}>
//                 <Banner />
//             </div>
//             <div className={` ${sellerBoolShowHomePageCategoriesTop ? '' : 'hidden'} `}>
//                 <Categorys />
//             </div>
//             <div className={` ${sellerBoolShowHomePageMainIngredientsTop ? '' : 'hidden'} `}>
//                 <MainIngredients />
//             </div>
//             <div className={` ${sellerBoolShowHomePageFavoriteProducts ? '' : 'hidden'} `}>
//                 <FeatureProducts products={featured_product} />                
//             </div>
//             <div className={` ${sellerBoolShowHomePageCategoriesBottom ? '' : 'hidden'} `}>
//                 <Categorys />
//             </div>
//             <div className={` ${sellerBoolShowHomePageMainIngredientsBottom ? '' : 'hidden'} `}>
//                 <MainIngredients />
//             </div>            
            
//             <div className={` ${sellerBoolShowHomePageThreeProductColumns ? 'py-10' : 'hidden'} `}
//                 style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium }}>
//                 <div className='w-[85%] flex flex-wrap mx-auto'>
//                     <div className='border-none grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-3'>
//                         <div className={` overflow-hidden border-none justify-items-center `}>
//                             <Products title={'Latest '+ sellerProductPluralTerm} products={latest_product} parentPage={'Home'} />
//                         </div>
//                         <div className={` overflow-hidden border-none justify-items-center `}>
//                             <Products  title={'Chefs Choice'} products={topRated_product} parentPage={'Home'} />
//                         </div>
//                         <div className={` overflow-hidden border-none justify-items-center `}>
//                             <Products  title={'Select '+ sellerProductPluralTerm} products={discount_product} parentPage={'Home'} />
//                         </div>
//                     </div> 
//                 </div> 
//             </div>
            
//             <div className={` ${sellerBoolShowCustomerTestimonials ? '' : 'hidden'} `}>
//                 <CustomerTestimonialsHomePage />
//             </div>
//             {
//             // <div className={` ${sellerBoolShowCustomerTestimonials ? 'hidden' : 'hidden'} `}>
//             //     <CustomerTestimonialsHomePage2 />
//             // </div>
//             }          
//             <Footer/>
//         </div>
//     );
// };

// export default Home;




